import { IconButton, Shadow, Text, Tooltip, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContentItemStatus } from '../../../../../../components/TableContent/status';
import { messageError } from '../../../../utils/constants';

import type { LayoutItemProps } from '.';

export const Tablet: React.FC<Partial<LayoutItemProps>> = ({
  data,
  onRemove,
  isDisabledButton,
  isLoading,
}) => {
  return (
    <Shadow level={2} borderRadius={BoxRadius.sm}>
      <VStack
        px={Spacing['inline.xxs']}
        py={Spacing['stack.xxxs']}
        space={Spacing['inset.nano']}
        borderRadius={BoxRadius.sm}>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack space={Spacing['inset.quarck']}>
            <Text
              color="neutral.darkest"
              noOfLines={1}
              isLoading={isLoading}
              {...(isLoading && { w: '300px' })}>
              {data?.customerName || messageError}
            </Text>
            <HStack alignItems="center" space={Spacing['inline.nano']}>
              <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
                Conta
              </Text>
              <Text
                fontSize={Typography['fontsize.xs']}
                color="neutral.dark"
                isLoading={isLoading}
                {...(isLoading && { maxW: '60px' })}>
                {data?.sinacorAccount || messageError}
              </Text>
            </HStack>
          </VStack>
          <IconButton
            testId="remove-item"
            borderRadius={BoxRadius.sm}
            isDisabled={isDisabledButton || isLoading}
            onPress={() => data?.id && onRemove && onRemove(data?.id, data?.basketCustomerOfferId)}
            w={Spacing['inline.sm']}
            h={Spacing['inline.sm']}
            iconColor={Color['feedback.error.default']}
            icon="Trash"
            p={0}
            iconSize="xs"
          />
        </HStack>
        <HStack alignItems="center" justifyContent="space-between">
          <VStack space={Spacing['stack.quarck']} maxW="110px">
            <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
              Produto
            </Text>
            <Text color="neutral.darkest" isLoading={isLoading} numberOfLines={1} w="110px">
              {data?.productType || messageError}
            </Text>
          </VStack>
          <VStack space={Spacing['stack.quarck']} w="160px">
            <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
              Ativo
            </Text>
            <Tooltip label={data?.assetName || messageError} isDisabled={isLoading}>
              <VStack>
                <Text color="neutral.darkest" isLoading={isLoading} noOfLines={1} w="160px">
                  {data?.assetName || messageError}
                </Text>
              </VStack>
            </Tooltip>
          </VStack>
          <VStack space={Spacing['stack.quarck']} w="120px">
            <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
              Valor da boleta
            </Text>
            <Text color="neutral.darkest" isLoading={isLoading} noOfLines={1} w="120px">
              {data?.ticketAmount || messageError}
            </Text>
          </VStack>
          {/* <VStack space={Spacing['stack.quarck']} w="120px">
            <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
              Valor liq. estimado
            </Text>
            <Text color="neutral.darkest" isLoading={isLoading} noOfLines={1} w="120px">
              {data?.estimatedNetValue || messageError}
            </Text>
          </VStack> */}
          <VStack space={Spacing['stack.quarck']}>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
              Status
            </Text>
            {isLoading ? (
              <Skeleton w="90px" h={Typography['fontsize.md']} borderRadius={BoxRadius.sm} />
            ) : (
              <TableContentItemStatus
                maxW={{ sm: '220px', lg: '110px' }}
                basketAdvisorStatus={data?.status}
                customTooltipLabel={data?.customError}
              />
            )}
          </VStack>
        </HStack>
      </VStack>
    </Shadow>
  );
};
